import React from 'react'
import { DatePicker, InputNumber, Tooltip, Typography } from 'antd'
import { valueType } from 'antd/es/statistic/utils'
import { HelpCircle } from 'react-feather'
import styled from 'styled-components'
import dayjs from 'dayjs'

import { FlexColumn, FlexRow } from '../../FlexboxReusables/FlexItems'
import { FormattedMessage, useIntl } from 'react-intl'

type ReviewCourseSettingsProps = {
    startDate: dayjs.Dayjs
    examDuration: number
    maxTries: number
    minimumExamDuration: number
    setStartDate: (date: dayjs.Dayjs) => void
    setExamDuration: (duration: number) => void
    setMaxTries: (tries: number) => void
}

const ReviewCourseSettings: React.FC<ReviewCourseSettingsProps> = (props: ReviewCourseSettingsProps) => {
  const {
    startDate,
    examDuration,
    minimumExamDuration,
    setStartDate,
    setExamDuration,
    maxTries,
    setMaxTries,
  } = props

  const intl = useIntl()

  return (
    <>
      <FlexRow justifyContent='flex-start' margin='0 0 2em 0'>
        <Typography.Title level={4}>
          <FormattedMessage id='exam.setExamTime' />
          <Tooltip title={intl.formatMessage({id: 'exam.setExamTimeTooltip'})}>
            <TooltipIcon size={16} />
          </Tooltip>
        </Typography.Title>
      </FlexRow>
      <FlexRow justifyContent='flex-start'>
        <FlexColumn width='50%'>
          <Typography.Text>
            <FormattedMessage id='exam.examStartsAt' />
          </Typography.Text>
          <StyledDatePicker
            value={startDate ? startDate : undefined}
            defaultValue={dayjs()}
            onChange={(date) => setStartDate(date || dayjs())}
          />
        </FlexColumn>
      </FlexRow>

      <FlexRow margin='2em 0' justifyContent='flex-start'>
        <FlexColumn width='50%'>
          <Typography.Text>
            <FormattedMessage id='exam.examDurationLong' />
          </Typography.Text>
          <StyledInputNumber
            value={examDuration}
            min={minimumExamDuration}
            max={240}
            onChange={(val: valueType | null) => typeof val === 'number' && setExamDuration(val)}
          />
        </FlexColumn>
        <FlexColumn width='50%'>
          <Typography.Text>
            <FormattedMessage id='exam.maxTries' />
          </Typography.Text>
          <StyledInputNumber
            value={maxTries}
            min={1}
            max={99}
            onChange={(val: valueType | null) => typeof val === 'number' && setMaxTries(val)}
          />
        </FlexColumn>
      </FlexRow>
    </>
  )
}

export default ReviewCourseSettings

const StyledDatePicker = styled(DatePicker)`
  margin: 0.5em 0;
`

const StyledInputNumber = styled(InputNumber)`
  margin: 0.5em 0;
`

const TooltipIcon = styled(HelpCircle)`
  margin-left: 0.5em;
  cursor: pointer;
`
